/**
 * ShieldBadge — a dimensional shield illustration (DS core): blue gradient body
 * with depth, white rim + gloss, a check mark, soft shadow. Pure SVG (scales
 * cleanly, owns its colours via tokens). Sizing via `className` (height + w-auto).
 */
export function ShieldBadge({ className = "h-[100px] w-auto" }: { className?: string }) {
  return (
    <svg viewBox="0 0 100 100" className={`${className} drop-shadow-[0_18px_28px_-10px_rgba(63,116,207,0.55)]`} aria-hidden>
      <defs>
        <linearGradient id="shieldFill" x1="0.2" y1="0" x2="0.75" y2="1">
          <stop offset="0" stopColor="var(--ds-accent)" />
          <stop offset="1" stopColor="var(--ds-accent-deep)" />
        </linearGradient>
      </defs>
      <path d="M50 6 C 41 14 24 18 10 19 C 10 47 15 78 50 96 C 85 78 90 47 90 19 C 76 18 59 14 50 6 Z" fill="url(#shieldFill)" stroke="white" strokeWidth="5" strokeLinejoin="round" />
      <path d="M50 10 C 42 17 26 21 13 22 L13 39 C 33 31 67 31 87 39 L87 22 C 74 21 58 17 50 10 Z" fill="white" opacity="0.16" />
      <path d="M35 51 l10 11 l21 -25" fill="none" stroke="white" strokeWidth="6.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
